<template>
  <div>
    <div class="left-aside">
      <div id="loginForm" class="registration-form">
        <div class="brand">
          <img :src="require('@/assets/img/logo-management.svg')" alt="">
        </div>

        <div class="hero-txt">
          <h2>Welcome</h2>
          <span>Enter your username / email and password to login.</span>
        </div>

        <form class="form-signin" @submit="sub">
          <div v-if="errorMessage">
            <div class="error-message">
              <!-- <img src="https://halcyon-api-files.s3-ap-southeast-1.amazonaws.com/cloud-assets/icon-error-mismatch.svg"> -->
              {{ errorMessage }}
            </div>
          </div>

          <div class="form-label-group">
            <label for="inputEmail">Enter Username or Email</label>
            <input type="text" id="inputEmail" class="form-control has-error" placeholder="Username or Email" autofocus v-model="login.username" maxlength="75" autocomplete="off">
          </div>

          <div class="form-label-group form-group-password">
            <label for="inputPassword">Password</label>
            <input type="password" id="inputPassword" class="form-control" placeholder="Password" name="current-password" v-model="login.password" maxlength="32" autocomplete="off">
            <!-- <span class="txt-center" style="display: block; margin-top: 10px;">Can't remember password? Click <a href="#/ForgotPassword" class="">Forgot password</a></span> -->
          </div>

          <div class="form-group form-check-forgot">
            <!-- <label for="rememberMe"><input type="checkbox" v-model="login.rememberMe" id="rememberMe"> Remember me</label> -->
            <div class="checkbox pull-left"><input type="checkbox" v-model="login.rememberMe" id="rememberMe"> <span>Remember me</span></div>
            <a href="#/ForgotPassword" class="pull-right">Forgot password</a>
            <div class="clearfix"></div>
          </div>

          <br>
          <button class="btn btn-lg btn-primary btn-block" type="submit" :disabled="isSubmitDisabled">Sign in</button>
          <div class="g-signin2" data-onsuccess="onSignIn">
            <!-- <GoogleLogin :params="params" :logoutButton=true>Logout</GoogleLogin> -->
          </div>
          <div class="txt-center">
            <span>Don't have an account? <a href="#/Registration" class="">Register</a></span>
          </div>
        </form>
      </div>
    </div>

    <div class="right-aside">
      <img :src="assets + 'register-gfx.jpg'" alt="" class="img-fluid">
    </div>
  </div>
</template>

<script>
import { post, objectToQuerystring } from '@/utils/http';
// import GoogleLogin from 'vue-google-login';

export default {
  name: 'Login',
  components: {
    // GoogleLogin
  },
  data() {
    return {
      assets: process.env.VUE_APP_ASSETS,
      errorMessage: "",
      isSubmitDisabled: false,
      login: {
        username: null,
        password: null
      },
      params: {
        client_id: "250585719459-deca271os1rmhmm0438a5i5kcumfg819.apps.googleusercontent.com"
      }
    }
  },
  mounted() {
    this.isRemember();
  },
  methods: {
    sub: function (event) {
      event.preventDefault();
      this.saveRemember();
      this.errorMessage = "";
      if (this.login.password && this.login.username) {
        this.isSubmitDisabled = true;
        this.$insProgress.start();
        post("/Api/Login", this.login, (response) => {
          this.$insProgress.finish();
          if (response.data.status == "NOT_FOUND") {
            this.errorMessage = "Invalid username or password.";
            // this.errorMessage = response.data.message  returning to null
          } else if (response.data.isForceChangePass) {
            this.$store.commit('CHANGE_PASSWORD', { authorization: response.data });
            this.$router.push("/ChangePassword");;
          } else {
            this.$router.push({ name: "LoginSuccess", params: response.data });
          }
          this.isSubmitDisabled = false;
        }, (error) => {
          this.$insProgress.finish();
          this.isSubmitDisabled = false;
          this.errorMessage = "Invalid username or password.";
        })
      }
      if (this.login.username === null || this.login.username == "") {
        this.errorMessage = "Username or Email is required.";
        this.isSubmitDisabled = false;
      } else if (this.login.password === null || this.login.password == "") {
        this.errorMessage = "Password is required.";
        this.isSubmitDisabled = false;
      }
    },
    saveRemember() {
      if (this.login.rememberMe && this.login.username != null && this.login.username.trim() != '') {
        this.setCookie("username", this.login.username);
        this.setCookie("rememberMe", this.login.rememberMe);
      } else {
        this.setCookie("username", "");
        this.setCookie("rememberMe", "");
      }
    },
    isRemember() {
      var rememberMe = this.getCookie("rememberMe");
      if (rememberMe && rememberMe !== "") {
        this.login.rememberMe = true;
        this.login.username = this.getCookie("username");
      } else {
        this.login.rememberMe = false;
        this.login.username = "";
      }
    },
    setCookie(cname, cvalue) {
      var d = new Date();
      var exdays = 30;
      d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
      var expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname) {
      var name = cname + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    onSignIn(googleUser) {
      var profile = googleUser.getBasicProfile();
      console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
      console.log('Name: ' + profile.getName());
      console.log('Image URL: ' + profile.getImageUrl());
      console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
    }
  }
}
</script>
